import { FETCH_COME_BACK_DOCTOR_FAIL, FETCH_COME_BACK_DOCTOR_REQUEST, FETCH_COME_BACK_DOCTOR_SUCCESS } from "../../ActionType/AffiarsOfSurgeryTypes/ComeBackDoctorType";

  export const getComeBackDoctorReducer = (
    state = { loading: true, comeBackDoctors: [], error: "" },
    action
  ) => {
    switch (action.type) {
      case FETCH_COME_BACK_DOCTOR_REQUEST:
        return {
          loading: true,
          comeBackDoctors:action.payload
        };
      case FETCH_COME_BACK_DOCTOR_SUCCESS:
        return {
          loading: false,
          comeBackDoctors:action.payload,
          error:"",
        };
      case FETCH_COME_BACK_DOCTOR_FAIL:
        return {
          loading: false,
          comeBackDoctors:action.payload,
          error:"",
        };
      default:
        return state;
    }
  };
  
  